module.exports = __webpack_public_path__ + "img/close.0e20ccb2.svg";